import React, { useState } from 'react';
import { Lock, User, Plane, AlertCircle } from 'lucide-react';

interface LoginFormProps {
  onLogin: (u: string, p: string) => Promise<void>;
}

const LoginForm: React.FC<LoginFormProps> = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);
    try {
        await onLogin(username, password);
    } catch (err: any) {
        setError(err.message || 'بيانات الدخول غير صحيحة');
    } finally {
        setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8 font-sans" dir="rtl">
      <div className="sm:mx-auto sm:w-full sm:max-w-md text-center">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-fly-600 text-white mb-4 shadow-lg shadow-fly-500/30">
            <Plane className="w-8 h-8" />
        </div>
        <h2 className="text-3xl font-bold text-slate-900">
          Fly Rent
        </h2>
        <p className="mt-2 text-sm text-slate-500">نظام إدارة العقارات المتكامل</p>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-10 px-8 shadow-xl shadow-slate-200/50 sm:rounded-2xl border border-slate-100">
          <form className="space-y-6" onSubmit={handleSubmit}>
            <div>
              <label className="block text-sm font-bold text-slate-700 mb-2">اسم المستخدم</label>
              <input type="text" value={username} onChange={(e) => setUsername(e.target.value)} required disabled={isLoading} className="block w-full px-4 py-3 bg-white border border-slate-300 rounded-xl text-slate-900 focus:ring-4 focus:ring-fly-500/10 focus:border-fly-500 transition-all disabled:opacity-50 disabled:bg-slate-50" />
            </div>

            <div>
              <label className="block text-sm font-bold text-slate-700 mb-2">كلمة السر</label>
              <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required disabled={isLoading} className="block w-full px-4 py-3 bg-white border border-slate-300 rounded-xl text-slate-900 focus:ring-4 focus:ring-fly-500/10 focus:border-fly-500 transition-all disabled:opacity-50 disabled:bg-slate-50" />
            </div>

            {error && (
              <div className="p-3.5 bg-rose-50 border border-rose-200 rounded-xl text-rose-600 text-sm font-bold flex items-center gap-2 animate-shake">
                <AlertCircle className="w-4 h-4 text-rose-500 shrink-0" />
                <span>{error}</span>
              </div>
            )}

            <button type="submit" disabled={isLoading} className="w-full py-3.5 px-4 rounded-xl shadow-lg shadow-fly-600/20 text-sm font-bold text-white bg-fly-600 hover:bg-fly-700 transition-all disabled:opacity-50 flex items-center justify-center gap-2">
              {isLoading ? (
                <>
                  <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  <span>جاري التحقق...</span>
                </>
              ) : (
                <span>تسجيل الدخول</span>
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;